/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingServiceException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when requested service is missing
 */
let MissingServiceException = exports.MissingServiceException = function (_Exception) {
  _inherits(MissingServiceException, _Exception);

  /**
   * @param {String} serviceName
   */
  function MissingServiceException(serviceName) {
    _classCallCheck(this, MissingServiceException);

    return _possibleConstructorReturn(this, (MissingServiceException.__proto__ || Object.getPrototypeOf(MissingServiceException)).call(this, `Missing service ${serviceName} in deep-kernel`));
  }

  return MissingServiceException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-di/lib.compiled/Exception/MissingServiceException.js
// module id = 378
// module chunks = 0